import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { AuthService, WMAIApiService } from '../core/services';
import { WgisService } from '../wgis/wgis.service';
import { Angulartics2 } from 'angulartics2';
import { Router } from '@angular/router';
import { TouchSequence } from 'selenium-webdriver';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
})

export class RegisterComponent implements OnInit {
  isSubmitting = false;
  registrationError = false;
  registrationSuccess = false;
  privacy = false;

  constructor(
    private auth: AuthService,
    private wgisservice: WgisService,
    private angulartics2: Angulartics2,
    private wmaiservice: WMAIApiService,
    private router: Router,
  ) {
    this.wgisservice.setMapInvisible();

    this.angulartics2.eventTrack.next({
      action: 'signUp',
      properties: { label: 'RegisterSignUp' },
    });
  }

  ngOnInit() {
  }
  /** registrati
   * @param  {NgForm} form
   */
  signUp(form: NgForm) {
    if (!form.valid) {
      return false;
    }

    this.registrationError = false;
    this.registrationSuccess = false;

    let promise = new Promise((resolve, reject) => { 
      this.auth.signUp(form.value.email, form.value.password).toPromise().then((data) => {
        this.registrationSuccess = data.id === null || data.id === "" ? false : true;
        if (this.registrationSuccess) {
          let email = data.email;
          let id = data.id;
          let uuid = data.uuid;
          this.wmaiservice.sendFirstLoginMail(email, uuid, id).subscribe(data => {
            this.router.navigate(['/']);
            resolve();
          });
        } else {
          this.registrationError = !this.registrationSuccess;
          resolve();
        }
      });
    });
  }
}
